<template>
  <div>
    <div class="pt-5">
      <div class="source">
        <p>
          <b>Sources 資料來源</b>
        </p>
      </div>
      <div class="pt-3 para">綜合香港醫務委員會投訴及紀律研訊, 以及傳媒報道</div>
      <div
        class="pt-1 pb-3 para"
      >Info from complaints and disciplinary Inquiries from the Medical Council of Hong Kong, and media reports</div>
      <div class="pt-2"></div>
      <span>資料來源摘錄自2018-2020年</span>
      <div class="pt-2"></div>
      <span>Source of info from 2018-2020</span>
    </div>
    <br />
    <br />
    <br />
    <div class="pt-3">
      <h2 class="page-title">Doctor Disciplinary Inquiry cases in Hong Kong</h2>
    </div>

    <div class="ml-3">
      <NegligenceMap />
    </div>

    <b-container class="pt-1 pb-5 mb-3">
      <b-row>
        <b-col cols="12" md="6">
          <div class="pt-2">
            <p>
              <b>有關投訴事宜，你可與香港醫務委員會聯絡:</b>
            </p>

            <span>
              <b>地址:</b>&nbsp;灣仔愛群道32號愛群商業大廈14樓1408室
            </span>
            <br />
            <span>
              <b>電話:</b> (852) 2243 3374 / 2243 3375
            </span>
            <br />
            <span>
              <b>電郵:</b> mc-complaint@dh.gov.hk
            </span>
            <br />
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="pt-md-2 px-md-0 pt-5 px-5">
            <p>
              <b>For matters relating to complaints, you may contact the Medical Council of Hong Kong:</b>
            </p>
            <span>
              <b>Address:</b>&nbsp;Room 1408, 14/F, Guardian House, 32 Oi Kwan Road, Wanchai
            </span>
            <br />
            <span>
              <b>Tel No.:</b>&nbsp;(852) 2243 3374 / 2243 3375
            </span>
            <br />
            <span>
              <b>Email:</b>&nbsp;mc-complaint@dh.gov.hk
            </span>
            <br />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
import NegligenceMap from "@/components/NegligenceMap.vue";

export default {
  components: {
    NegligenceMap
  }
};
</script>

<style scoped>
.about-card {
  margin: auto;
  max-width: 1000px;
  margin-bottom: 100px;
}

.page-title {
  text-align: left;
  padding-left: 6rem;
}

@media only screen and (max-width: 600px) {
  .page-title {
    padding-left: 1.5rem;
  }
}

.source {
  margin-left: 15%;
  margin-right: 15%;
  border-bottom: 1px solid darkslategrey;
}

.para {
  margin-left: 15%;
  margin-right: 15%;
}
</style>
